import type { ReactNode } from 'react'

import { useTheme } from '@emotion/react'

import * as commonStyles from '../common.styles'
import { useTableSection } from '../table-section.context'

import * as styles from './table.styles'

type Props = {
  children?: ReactNode
  align?: keyof typeof commonStyles.alignments
  bold?: boolean
  scope?: string
  component?: 'td' | 'th'
  role?: 'cell' | 'columnheader'
  className?: string
}

export const TableCell = ({
  children,
  align = 'left',
  bold = false,
  component,
  role = 'cell',
  ...others
}: Props) => {
  const theme = useTheme()
  const { Component } = useTableSection({ component })

  const componentCss = [
    styles.tableCell(theme),
    commonStyles.alignments[align],
    bold && styles.fontWeightBold,
  ]

  return (
    <Component
      css={componentCss}
      data-testid="table-cell"
      role={role}
      {...others}
    >
      {children}
    </Component>
  )
}
